import { render } from "./ViewPlayBookComponent.vue?vue&type=template&id=07b6548f&scoped=true&ts=true"
import script from "./ViewPlayBookComponent.vue?vue&type=script&lang=ts"
export * from "./ViewPlayBookComponent.vue?vue&type=script&lang=ts"

import "./ViewPlayBookComponent.vue?vue&type=style&index=0&id=07b6548f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b6548f"]])

export default __exports__